import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
/**
 * Hook for resending a verification email.
 * This is a fire-and-forget mutation.
 */
export const useResendVerificationEmail = () => {
    return useMutation({
        mutationFn: (data) => apiClient.auth.resendVerificationEmail(data),
    });
};
//# sourceMappingURL=useResendVerificationEmail.js.map